import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { registerScreenActions, registerScreenPanels } from '../../../studio-nav/screen-panels.service';
import type { ScreenActionAnswer } from '../../../services/mcp/actions/fast-lane';
import { PageService } from '../../../services/page.service';
import { Page } from '../../../model/page.model';
import { EntityService } from '../../../services/entity.service';
import { Entity, TypeData } from '../../../model/entity.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalVariablesService } from '../../../services/global-variables.service';
// Was (2026-10-16): import {
// Was (2026-10-16):   ref,
// Was (2026-10-16):   Storage,
// Was (2026-10-16):   uploadBytes,
// Was (2026-10-16): } from '@angular/fire/storage';
import { IconService } from '../../../services/icon.service';
import { ClientService } from '../../../services/client.service';
import { IconClass } from '../../../model/icon.model';
// Was (2026-10-16): import { StorageUrlCacheService } from '../../../services/storage-url-cache.service';
import { IconSourceService } from '../../../services/icon-source.service';
import { iconRefOf } from '../../../services/icon-library';

@Component({
    selector: 'app-page-data',
    imports: [CommonModule, FormsModule],
    templateUrl: './page-data.component.html'
})
export class PageDataComponent {
  // Was (2026-10-16): private storage = inject(Storage);
  // Was (2026-10-16): private storageUrlCache = inject(StorageUrlCacheService);
  private iconSource = inject(IconSourceService);

  pageData: Page = {
    type: 'web',
    name: 'Strange',
    id: 'Strange_123WWD',
    sections: [],
    entites: [],
    localVariable: {
      defaultFlag: false,
      defaultString: '',
      defaultNumber: 0,
    },
    functions: [],
  };
  selectedNewEntity: string = '';
  entityList: Entity[] = [];
  filteredEntityList: Entity[] = [];
  globalVariables: any;
  pageDataEntity: Entity[] = [];
  constructor(
    private pageService: PageService,
    private entityService: EntityService,
    private router: Router,
    public globalVariablesService: GlobalVariablesService,
    public iconService: IconService,
    private client: ClientService
  ) {
    this.iconService.$values.subscribe(async (value: IconClass[]) => {
      const promises = value.map(async (icon) => {
        const url = await this.getURL(icon);
        return { ...icon, url };
      });
      this.icons = await Promise.all(promises);
    });
    // Was (2026-10-16): this.iconService.query(100);
    this.pageData = this.pageService.selectedPage;
    // this.pageData.entites = ['sample_test_MTA0ND'];
    this.entityService.$values.subscribe((value: any) => {
      this.entityList = this.filterFinalizedEntityList(value);
      this.filteredEntityList = this.filterEntityList();
      this.pageDataEntity = this.pageDataEntityList();
    });
    this.globalVariables = structuredClone(
      this.globalVariablesService.globalVariable
    );
    this.lastSaved = this.pendingNow();
  }
  // to allow only finalized entry
  filterFinalizedEntityList(list: Entity[]) {
    var returnList: Entity[] = [];
    for (let i = 0; i < list.length; i++) {
      if (list[i].status == 'READY' || list[i].status == 'PENDING' || list[i].status == 'SYNCED' || list[i].status == 'ERROR' || list[i].status == 'LOCAL') {
        if (list[i].type == 'TABLE') {
          returnList.push(list[i]);
        }
      }
    }
    return returnList;
  }
  filterEntityList() {
    var array = [...this.entityList];
    for (let i = 0; i < array.length; i++) {
      for (let j = 0; j < this.pageData.entites.length; j++) {
        if (array[i] && this.pageData.entites[j] == array[i].id) {
          array.splice(i, 1);
          i = i - 1;
          // if(i== -1)
          // break;
        }
      }
    }
    return array;
  }

  pageDataEntityList() {
    var array: any[] = [];
    for (let i = 0; i < this.entityList.length; i++) {
      for (let j = 0; j < this.pageData.entites.length; j++) {
        if (
          this.entityList[i] &&
          this.pageData.entites[j] == this.entityList[i].id
        ) {
          array.push(this.entityList[i]);
        }
      }
    }
    return array;
  }
  // adding local variable
  addLocalVariableFlag = false;
  private panels = registerScreenPanels({
    screen: 'page-data',
    here: () => (this.addLocalVariableFlag ? { panel: 'add-variable' } : {}),
    holds: () => ({
      pageEntities: this.pageData?.entites ?? [],
      entityChoices: this.entityChoices(),
      variables: this.pageData?.localVariable ?? {},
      selectedNewEntity: this.selectedNewEntity,
      variableName: this.newVariableData.name,
      variableType: this.newVariableData.type,
      variableValue: this.newVariableData.value,
    }),
    select: () => {
      this.addLocalVariableFlag = true;
      return true;
    },
    unsaved: () => {
      const count = this.unsavedCount();
      return count > 0 ? { count, name: `Page data for ${this.pageData?.name}` } : null;
    },
  });
  private offers = registerScreenActions({
    'add-page-entity': (values) => this.addEntityFor(values),
    'add-page-variable': (values) => this.addVariableFor(values),
    'save-page-data': () => this.saveFor(),
  });
  addGlobalVaraibleFlag = false;
  addIconFlag = false;
  newIcon = { ...emptyIcon };
  icons: any = [];
  /** Why the library refused the last Add image — shown in the modal, which stays open for another file or name. */
  iconAddError = '';

  saveGlobalVarirableFlag = false;
  newVariableData: {
    name: string;
    type: string;
    value: any;
  } = { name: '', type: 'BOOLEAN', value: false };

  dataTypes = ['BOOLEAN', 'STRING', 'TIMESTAMP' , 'NUMBER', 'ENTITY', 'ARRAY_OF_OBJECT', 'GEOMETRY'];
  changeAddGlobalVariableFlag() {
    this.addGlobalVaraibleFlag = !this.addGlobalVaraibleFlag;
    this.changeAddLocalVariableFlag();
  }
  changeAddLocalVariableFlag() {
    this.addLocalVariableFlag = !this.addLocalVariableFlag;
  }

  changeAddIconFlag() {
    this.addIconFlag = !this.addIconFlag;
    // A modal that opens is empty: no refusal or file from the last time.
    if (this.addIconFlag) {
      this.iconAddError = '';
      this.selectedFile = null;
      this.filePreviewUrl = null;
    }
  }

  async saveIcon() {
    if (!this.selectedFile) {
      console.warn('No file selected');
      return; // Don't proceed if no file is selected
    }
    if(this.newIcon.name == '') {
      alert('file name cannot be empty');
      return; // Don't proceed if no file is selected
    }
    if (!this.newIcon.file) {
      console.warn('No file selected');
      return;
    }
    // Was (2026-10-16): const isDuplicate = this.icons.some(
    // Was (2026-10-16):   (icon: IconClass) => icon.name === this.newIcon.name
    // Was (2026-10-16): );
    // Was (2026-10-16): if (isDuplicate) {
    // Was (2026-10-16):   alert('Icon with this name already exists');
    // Was (2026-10-16):   return;
    // Was (2026-10-16): }
    // Was (2026-10-16): const originalFileName = (this.newIcon.file as any).name as string;
    // Was (2026-10-16): const uniqueSuffix = this.generateShortId(5);
    // Was (2026-10-16): const fileName = this.appendSuffixToFileName(originalFileName, uniqueSuffix);
    // Was (2026-10-16): console.log('Uploading file', this.newIcon);
    // Was (2026-10-16): const storageRef = ref(
    // Was (2026-10-16):   this.storage,
    // Was (2026-10-16):   `${this.client.selectedClientId}/icons/${fileName}`
    // Was (2026-10-16): );
    // Was (2026-10-16):
    // Was (2026-10-16): // Upload with cache control metadata for maximum caching
    // Was (2026-10-16): const metadata = {
    // Was (2026-10-16):   cacheControl: 'public, max-age=31536000, immutable', // 1 year cache
    // Was (2026-10-16):   contentType: this.getContentTypeFromFileName(fileName)
    // Was (2026-10-16): };
    // Was (2026-10-16):
    // Was (2026-10-16): const result = await uploadBytes(storageRef, this.newIcon.file, metadata);
    // Was (2026-10-16): const path = result.ref.fullPath;
    // Was (2026-10-16): console.log('Uploaded file', result.ref);
    // Was (2026-10-16): await this.iconService.create({
    // Was (2026-10-16):   name: this.newIcon.name,
    // Was (2026-10-16):   fileName,
    // Was (2026-10-16):   path,
    // Was (2026-10-16):   id: this.newIcon.name,
    // Was (2026-10-16): });
    // The library checks the name (case does not count), shrinks or refuses the image, and keeps it whole. A refusal
    // is shown in the modal in the library's own words.
    this.iconAddError = '';
    try {
      // Cancelled in the preview: nothing was stored, so the modal stays as it was for another choice.
      if (!(await this.iconService.add(this.selectedFile, this.newIcon.name))) return;
    } catch (e: any) {
      this.iconAddError = e?.message || 'The image could not be added.';
      return;
    }
    this.newIcon = { ...emptyIcon };
    this.changeAddIconFlag();
    // Was (2026-10-16): this.iconService.query(100);
  }

  /**
   * Helper method to determine content type from file name
   */
  private getContentTypeFromFileName(fileName: string): string {
    const extension = fileName.toLowerCase().split('.').pop();
    
    switch (extension) {
      case 'svg':
        return 'image/svg+xml';
      case 'png':
        return 'image/png';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      case 'gif':
        return 'image/gif';
      case 'webp':
        return 'image/webp';
      case 'ico':
        return 'image/x-icon';
      default:
        return 'application/octet-stream';
    }
  }

  private generateShortId(length: 4 | 5 = 5): string {
    // Prefer cryptographically-strong randomness when available
    try {
      const alphabet = 'abcdefghijklmnopqrstuvwxyz0123456789';
      const bytes = new Uint8Array(length);
      crypto.getRandomValues(bytes);
      let out = '';
      for (let i = 0; i < bytes.length; i++) {
        out += alphabet[bytes[i] % alphabet.length];
      }
      return out;
    } catch {
      return Math.random().toString(36).slice(2, 2 + length).padEnd(length, '0');
    }
  }

  private appendSuffixToFileName(fileName: string, suffix: string): string {
    const lastDot = fileName.lastIndexOf('.');
    if (lastDot <= 0 || lastDot === fileName.length - 1) {
      return `${fileName}_${suffix}`;
    }
    const base = fileName.slice(0, lastDot);
    const ext = fileName.slice(lastDot + 1);
    return `${base}_${suffix}.${ext}`;
  }

  selectedFile: File | null = null;
  filePreviewUrl: string | null = null;
  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement> | undefined;

  onFileChange(event: any): void {
    if (event.target.files && event.target.files.length) {
      this.selectedFile = event.target.files[0];
      
      // Create preview URL for images
      if (this.selectedFile?.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = () => {
          this.filePreviewUrl = reader.result as string;
        };
        reader.readAsDataURL(this.selectedFile);
      } else {
        this.filePreviewUrl = null;
      }
      
      // Update the newIcon object with the file
      this.newIcon.file = (this.selectedFile as any);
    }
  }

  removeSelectedFile(): void {
    this.selectedFile = null;
    this.filePreviewUrl = null;
    if(this.fileInput)
    this.fileInput.nativeElement.value = '';
    
    // Also remove from the newIcon model
    this.newIcon.file = null;
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }



  variableNameChanged() {
    this.newVariableData.name = this.newVariableData.name.replace(
      /[^a-zA-Z_]/g,
      ''
    );
  }
  newVariableTypeChanged() {
    if (this.newVariableData.type == 'BOOLEAN') {
      this.newVariableData.value = false;
    } else if (this.newVariableData.type == 'STRING') {
      this.newVariableData.value = '';
    } else if (this.newVariableData.type == 'TIMESTAMP') {
      this.newVariableData.value = new Date().toISOString();
    } else if (this.newVariableData.type == 'GEOMETRY') {
      this.newVariableData.value = { type: 'Polygon', coordinates: [] };
    } else if (this.newVariableData.type == 'NUMBER') {
      this.newVariableData.value = 0;
    } else if (this.newVariableData.type == 'ENTITY') {
      this.newVariableData.value = {
        entityId: '',
        entityName: '',
        type: 'ENTITY',
        data: {},
      };
    } else if (this.newVariableData.type == 'ARRAY_OF_OBJECT') {
      this.newVariableData.value = {
        entityId: '',
        entityName: '',
        type: 'ARRAY_OF_OBJECT',
        data: [],
      };
    }
  }
  newVariableValueChanged() {
    if (
      this.newVariableData.type == 'ENTITY' ||
      this.newVariableData.type == 'ARRAY_OF_OBJECT'
    ) {
      this.newVariableData.value.entityName = this.getEntityNameById(
        this.newVariableData.value.entityId
      );

      if (this.newVariableData.value.entityName == '') {
        for (let entity of this.toBeAddedEntityName) {
          if (this.newVariableData.value.entityId === entity.id) {
            this.newVariableData.value.entityName = entity.name;
            break;
          }
        }
      }
    }
  }
  addLocalVariable() {
    const refusal = this.runAddLocalVariable();
    if (refusal) {
      alert(refusal);
      return false;
    }
    return true;
  }
  /** The Add Variable button's rules and work, with a refusal handed back: a dialog would freeze the screen on a call from do_action. */
  private runAddLocalVariable(): string | null {
    if (this.newVariableData.name == '') {
      return 'variable cannot be empty';
    }
    // Entity/AOB MUST have an entity selected — without it the variable is unusable
    if (this.newVariableData.type === 'ENTITY' || this.newVariableData.type === 'ARRAY_OF_OBJECT') {
      if (!this.newVariableData.value?.entityId) {
        return 'Please select an entity';
      }
    }
    if (this.addGlobalVaraibleFlag) {
      for (const key of Object.keys(this.globalVariables)) {
        if (key == this.newVariableData.name) {
          return 'variable name already exists';
        }
      }
    } else {
      for (const key of Object.keys(this.pageData.localVariable)) {
        if (key == this.newVariableData.name) {
          return 'variable name already exists';
        }
      }
    }
    
    // Populate default values if not present
    if (this.newVariableData.value === null || this.newVariableData.value === undefined || this.newVariableData.value === '') {
      if (this.newVariableData.type === 'BOOLEAN') {
        this.newVariableData.value = false;
      } else if (this.newVariableData.type === 'STRING') {
        this.newVariableData.value = '';
      }  else if (this.newVariableData.type === 'TIMESTAMP') {
        this.newVariableData.value = new Date().toISOString();
      } else if (this.newVariableData.type === 'GEOMETRY') {
        this.newVariableData.value = { type: 'Polygon', coordinates: [] };
      } else if (this.newVariableData.type === 'NUMBER') {
        this.newVariableData.value = 0;
      } else if (this.newVariableData.type === 'ENTITY') {
        this.newVariableData.value = {
          entityId: '',
          entityName: '',
          type: 'ENTITY',
          data: {},
        };
      } else if (this.newVariableData.type === 'ARRAY_OF_OBJECT') {
        this.newVariableData.value = {
          entityId: '',
          entityName: '',
          type: 'ARRAY_OF_OBJECT',
          data: [],
        };
      }
    }
    
    // have to handle all types
    if (this.newVariableData.type == 'BOOLEAN') {
      if (this.newVariableData.value == 'true') {
        this.newVariableData.value = true;
      } else if (this.newVariableData.value == 'false') {
        this.newVariableData.value = false;
      }
    } else if (this.newVariableData.type == 'ENTITY') {
      if (this.newVariableData.value == 'true') {
        this.newVariableData.value = true;
      }
    }
    if (this.addGlobalVaraibleFlag) {
      this.globalVariables[this.newVariableData.name] =
        this.newVariableData.value;
      this.changeAddGlobalVariableFlag();
      this.saveGlobalVarirableFlag = true;
    } else {
      this.pageData.localVariable[this.newVariableData.name] =
        this.newVariableData.value;
      this.changeAddLocalVariableFlag();
    }
    this.newVariableData = { name: '', type: 'BOOLEAN', value: false };
    return null;
  }
  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }
  trackByValue = (_: number, item: string) => item;
  getDataType(data: any) {
    if (typeof data == 'object') return data.type;
    return typeof data;
  }
  //add external entity to the page
  addEntity() {
    const refusal = this.runAddEntity();
    if (refusal) alert(refusal);
  }
  private runAddEntity(): string | null {
    if (this.selectedNewEntity !== '') {
      this.pageData.entites.push(this.selectedNewEntity);
      this.selectedNewEntity = '';

      this.filteredEntityList = this.filterEntityList();
      this.pageDataEntity = this.pageDataEntityList();
      return null;
    }
    return 'select an entity';
  }
  //save the changes
  async SavePageDataChanges(): Promise<void> {
    if (this.savingPageData) return;
    const failure = await this.writePageData();
    if (failure) {
      alert(failure);
      return;
    }
    await this.router.navigate(['/dashboard/pages']);
  }
  savingPageData = false;
  /** Waits for both writes and says what failed, so nobody is moved off the screen, or told it saved, on a write that didn't land. */
  private async writePageData(): Promise<string | null> {
    this.savingPageData = true;
    try {
      try {
        await this.pageService.create(this.pageData);
      } catch (e: any) {
        return `The page's data wasn't saved: ${e?.message ?? e}`;
      }
      this.lastSaved = this.pendingNow();
      if (this.saveGlobalVarirableFlag) {
        try {
          await this.globalVariablesService.create(this.globalVariables);
        } catch (e: any) {
          return `The page's data was saved, but its global variables weren't: ${e?.message ?? e}`;
        }
        this.saveGlobalVarirableFlag = false;
      }
      return null;
    } finally {
      this.savingPageData = false;
    }
  }

  // ── what's waiting for Save, and the same buttons for do_action ──────────────────────────────────
  // Add entity and Add variable change only the page in memory, and the screen has no guard of its own.

  private lastSaved: { entities: string[]; variables: Record<string, string> } = { entities: [], variables: {} };

  private pendingNow(): { entities: string[]; variables: Record<string, string> } {
    const variables: Record<string, string> = {};
    for (const [name, value] of Object.entries(this.pageData?.localVariable ?? {})) variables[name] = JSON.stringify(value);
    return { entities: [...(this.pageData?.entites ?? [])], variables };
  }

  private unfilledDraft(): boolean {
    return this.selectedNewEntity !== ''
      || (this.addLocalVariableFlag && this.newVariableData.name !== '')
      || (this.addIconFlag && (this.newIcon.name !== '' || !!this.selectedFile));
  }

  private unsavedCount(): number {
    const now = this.pendingNow();
    const entities = now.entities.filter((id) => !this.lastSaved.entities.includes(id)).length
      + this.lastSaved.entities.filter((id) => !now.entities.includes(id)).length;
    const names = new Set([...Object.keys(now.variables), ...Object.keys(this.lastSaved.variables)]);
    const variables = [...names].filter((name) => now.variables[name] !== this.lastSaved.variables[name]).length;
    return entities + variables + (this.saveGlobalVarirableFlag ? 1 : 0) + (this.unfilledDraft() ? 1 : 0);
  }

  private entityChoices(): { id: string; name: string }[] {
    return this.filteredEntityList.map((e) => ({ id: e.id, name: e.name }));
  }

  private async addEntityFor(values: Record<string, unknown>): Promise<ScreenActionAnswer> {
    if (this.unfilledDraft()) return { refused: 'The builder has this form half filled in; ask them to finish or clear it first. Nothing was changed.' };
    const id = String(values['selectedNewEntity'] ?? '');
    if (id && !this.filteredEntityList.some((e) => e.id === id)) {
      const choices = this.entityChoices().map((e) => `${e.name} (${e.id})`).join(', ');
      return { refused: `This page can't take "${id}". Nothing was changed. It can take: ${choices || 'none'}.` };
    }
    this.selectedNewEntity = id;
    const refusal = this.runAddEntity();
    if (refusal) return { refused: `${refusal}. Nothing was changed.` };
    return { done: `Added ${this.getEntityNameById(id)} to the page. It isn't saved until save-page-data.`, result: { entity: { id, name: this.getEntityNameById(id) }, unsaved: true } };
  }

  /** Sets what the dialog's type and value controls would, or says what those controls wouldn't have allowed. */
  private fillVariableValue(raw: unknown): string | null {
    const type = this.newVariableData.type;
    if (type === 'ENTITY' || type === 'ARRAY_OF_OBJECT') {
      if (raw === undefined) return null;
      if (!this.pageDataEntity.some((e) => e.id === raw)) {
        return `${type} takes one of this page's entities: ${this.pageDataEntity.map((e) => `${e.name} (${e.id})`).join(', ') || 'none yet'}.`;
      }
      this.newVariableData.value.entityId = raw;
      this.newVariableValueChanged();
      return null;
    }
    if (raw === undefined) return null;
    if (type === 'BOOLEAN') {
      if (raw !== 'true' && raw !== 'false') return 'BOOLEAN takes "true" or "false".';
      this.newVariableData.value = raw;
    } else if (type === 'NUMBER') {
      const n = Number(raw);
      if (raw === '' || !Number.isFinite(n)) return 'NUMBER takes a number.';
      this.newVariableData.value = n;
    } else if (type === 'STRING') {
      this.newVariableData.value = raw;
    } else {
      return `${type} has no value to set here.`;
    }
    return null;
  }

  private async addVariableFor(values: Record<string, unknown>): Promise<ScreenActionAnswer> {
    if (this.addGlobalVaraibleFlag || this.unfilledDraft()) return { refused: 'The builder has this form half filled in; ask them to finish or clear it first. Nothing was changed.' };
    const type = String(values['variableType'] ?? 'BOOLEAN');
    if (!this.dataTypes.includes(type)) return { refused: `variableType takes one of: ${this.dataTypes.join(', ')}. Nothing was changed.` };

    const before = { open: this.addLocalVariableFlag, data: this.newVariableData };
    const giveBack = () => {
      this.addLocalVariableFlag = before.open;
      this.newVariableData = before.data;
    };
    this.newVariableData = { name: String(values['variableName'] ?? ''), type, value: false };
    this.variableNameChanged();
    this.newVariableTypeChanged();
    const name = this.newVariableData.name;

    const problem = this.fillVariableValue(values['variableValue']);
    if (problem) {
      giveBack();
      return { refused: `${problem} Nothing was changed.` };
    }
    // The button toggles the dialog closed, so the dialog has to count as open when it runs.
    this.addLocalVariableFlag = true;
    const refusal = this.runAddLocalVariable();
    if (refusal) {
      giveBack();
      return { refused: `${refusal}. Nothing was changed.` };
    }
    const value = this.pageData.localVariable[name];
    return { done: `Added the variable ${name}. It isn't saved until save-page-data.`, result: { variable: { name, type, value }, unsaved: true } };
  }

  private async saveFor(): Promise<ScreenActionAnswer> {
    if (this.savingPageData) return { refused: 'The page\'s data is already saving; try again in a moment.' };
    if (this.unfilledDraft()) return { refused: 'The builder has a form half filled in that this would drop; ask them to finish or clear it first. Nothing was saved.' };
    const failure = await this.writePageData();
    if (failure) return { refused: failure };
    await this.router.navigate(['/dashboard/pages']);
    return {
      done: `Saved the data of ${this.pageData.name} and moved to Pages.`,
      result: { saved: { entities: [...this.pageData.entites], variables: { ...this.pageData.localVariable } }, screen: 'pages' },
    };
  }
  toBeAddedEntityName: { name: string; id: string }[] = [];
  getNestedEntitesFlatFromEntityID(entityId: string) {
    var array: { name: string; id: string }[] = [];
    for (let entity of this.pageService.newEntityListForSelected) {
      if (entityId == entity.id) {
        array = this.getEntitesRecursively(entity.data);
        break;
      }
    }
    this.toBeAddedEntityName = array;
    return array;
  }
  getEntitesRecursively(entityData: TypeData[]) {
    var array: { name: string; id: string }[] = [];
    for (let variable of entityData) {
      if (variable.type == 'ARRAY_OF_OBJECT') {
        array.push({ name: variable.name, id: variable.id });
        array = [...array, ...this.getEntitesRecursively(variable.data)];
      }
    }
    return array;
  }

  getEntityNameById(entityId: string) {
    for (let entity of this.entityList) {
      if (entity.id == entityId) return entity.name;
    }
    return '';
  }

  iconNameChanged() {
    this.newIcon.name = this.newIcon.name.replace(/[^a-zA-Z0-9_]/g, '');
  }
  async getURL(icon: IconClass) {
    // Was (2026-10-16): return await this.storageUrlCache.getDownloadURL(icon.path);
    // The same answer a page gets: the icon itself, or its file before the migration reaches it.
    return this.iconSource.resolve(iconRefOf(icon.id)).catch(() => '');
  }
}

const emptyIcon = {
  name: '',
  filePath: '',
  file: null,
};
